export enum AchievementCheckOperatorType {
  Manual = 'manual',
  AtLeast = 'atLeast',
  HasCompleted = 'hasCompleted',
}

/**
 * Types of rewards that can be associated with achievements
 */
export enum AchievementRewardType {
  None = 0,
  /** Unlocks an episode */
  Episode = 1,
  /** Unlocks a game pass */
  GamePass = 2,
  /** Achievement reward for playerHas checks */
  HasAchievement = 3,
}

export enum AchievementVisibility {
  Visible = 0,
  Hidden = 1,
  HiddenUntilUnlocked = 2,
}

export interface IAchievementCheck {
  variableId: number,
  operator: AchievementCheckOperatorType | '',
  value: string | number,
}

export interface IAchievementReward {
  id?: number,
  type?: AchievementRewardType,
  contentId: string | null,
  name?: string,
  deleted?: boolean,
  quantity?: number,
  delaySec?: number,
  achievementLabel?: string,
  createdAt?: string,
  updatedAt?: string,
}

export interface IAchievementUsedInStory {
  Node: string,
  Episode: string,
  Chapter: number,
  EpisodeId: number,
  Book: string,
  BookId: number,
  Revision: number,
  AchievementId: string,
}

export interface INotification {
  id?: number,
  title: string,
  message: string,
  createdAt?: string,
  updatedAt?: string,
}

export interface IAchievementGetDTO {
  id: number | string,
  name: string,
  icon: string,
  displayName: string,
  description: string,
  order: number,
  isManual: boolean,
  check: IAchievementCheck,
  usedInStory: IAchievementUsedInStory[],
  isOwnedByUser: boolean,
  unavailableAfter: string | undefined,
  hidden: number,
  notification: INotification,
  rewards: IAchievementReward[],
}

export interface IAchievementPostDTO {
  name: string,
  icon: string | null,
  displayName: string,
  description: string,
  isManual: boolean,
  check: IAchievementCheck,
  rewards: IAchievementReward[],
  unavailableAfter: string | undefined,
  hidden: number,
  notification: INotification,
}

export const GAME_PASS_ACHIEVEMENT_NAME = 'GamePass';
